export {
    default as getDimensionsConstrainedToContainer,
} from './getDimensionsConstrainedToContainer.js';
export {
    default as getDimensionsConstrainedToContainerWidth,
} from './getDimensionsConstrainedToContainerWidth.js';
export { default as getLinkTargetPath } from './getLinkTargetPath.js';
export { default as getLinkTargetUrl } from './getLinkTargetUrl.js';



// WEBPACK FOOTER //
// ./~/@99designs/utils/dom/index.js